import React, { useState, useEffect } from 'react';
import { getTeamsByOrganization } from '../../api';
import './UpdateCustomerDataDialog.css';

function UpdateCustomerDataDialog({ customer, user, onSave, onCancel }) {
  console.log("🔍 Customer:", customer);
  const [formData, setFormData] = useState({
    name: customer.name || '',
    nachname: customer.nachname || '',
    ansprache: customer.ansprache || '',
    email: customer.email || '',
    strasse: customer.strasse || '',
    hausnummer: customer.hausnummer || '',
    postleitzahl: customer.postleitzahl || '',
    stadt: customer.stadt || '',
    handy: customer.handy || '',
    produkt: customer.produkt || '',
    dienstleister: customer.dienstleister || '',
    projekt: customer.projekt || '',
    customer_status: customer.customer_status || 'Erfasst'
  });

  const [teams, setTeams] = useState([]);
  const [loadingTeams, setLoadingTeams] = useState(false);

  // Teams aus der Organisation laden
  useEffect(() => {
    const loadTeams = async () => {
      if (!user?.id) return;
      
      setLoadingTeams(true);
      try {
        // Für Callcenter-Mitarbeiter (5) und Callcenter-Leiter (4): Alle Projekte aus allen Organisationen
        // Für andere Rollen: Nur Projekte aus der eigenen Organisation
        const isCallcenter = user?.role_type === 4 || user?.role_type === 5;
        const organizationId = isCallcenter ? null : user?.organization_id;
        
        const response = await getTeamsByOrganization(user.id, organizationId);
        if (response.success && response.teams) {
          setTeams(response.teams);
        }
      } catch (error) {
        console.error('Fehler beim Laden der Teams:', error);
      } finally {
        setLoadingTeams(false);
      }
    };

    loadTeams();
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <h2>Kundendaten bearbeiten</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="ansprache">Anrede</label>
            <select
              id="ansprache"
              name="ansprache"
              value={formData.ansprache}
              onChange={handleChange}
              required
            >
              <option value="">Bitte wählen...</option>
              <option value="herr">Herr</option>
              <option value="frau">Frau</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="vorname">Vorname</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="nachname">Nachname</label>
            <input
              type="text"
              id="nachname"
              name="nachname"
              value={formData.nachname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">E-Mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="strasse">Straße</label>
            <input
              type="text"
              id="strasse"
              name="strasse"
              value={formData.strasse}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="hausnummer">Hausnummer</label>
            <input
              type="text"
              id="hausnummer"
              name="hausnummer"
              value={formData.hausnummer}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="postleitzahl">Postleitzahl</label>
            <input
              type="text"
              id="postleitzahl"
              name="postleitzahl"
              value={formData.postleitzahl}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="stadt">Stadt</label>
            <input
              type="text"
              id="stadt"
              name="stadt"
              value={formData.stadt}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="handy">Telefon</label>
            <input
              type="text"
              id="handy"
              name="handy"
              value={formData.handy}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="produkt">Produkt</label>
            <input
              type="text"
              id="produkt"
              name="produkt"
              value={formData.produkt}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="dienstleister">Dienstleister</label>
            <input
              type="text"
              id="dienstleister"
              name="dienstleister"
              value={formData.dienstleister}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="projekt">Projekt</label>
            <select
              id="projekt"
              name="projekt"
              value={formData.projekt}
              onChange={handleChange}
              disabled={loadingTeams}
            >
              <option value="">-- Projekt auswählen --</option>
              {teams.map(team => (
                <option key={team.id} value={team.name}>
                  {team.name}
                </option>
              ))}
            </select>
            {loadingTeams && <span style={{ fontSize: '12px', color: '#718096' }}>Lade Projekte...</span>}
          </div>

          <div className="form-group">
            <label htmlFor="customer_status">Kundenstatus</label>
            <select
              id="customer_status"
              name="customer_status"
              value={formData.customer_status}
              onChange={handleChange}
              className="status-select"
            >
              <option value="Erfasst">Erfasst</option>
              <option value="Terminiert">Terminiert</option>
              <option value="Termin Storniert">Termin Storniert</option>
              <option value="On Hold">On Hold</option>
              <option value="In Klärung">In Klärung</option>
            </select>
          </div>

          <div className="dialog-actions">
            <button type="button" onClick={onCancel} className="cancel-button">
              Abbrechen
            </button>
            <button type="submit" className="save-button">
              Speichern
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default UpdateCustomerDataDialog; 